import type { LuminarySettings } from '@lumen5/luminary';

import { SourceEnum } from 'js/src/client';
import { isOnMobileDevice } from 'js/src/libs/mobile-check';
import { hasFeatureEnabled } from 'js/src/libs/server-utils';

// all media sources that users need to pay to access (unlimited use & credit)
export const PREMIUM_SOURCES = new Set([
    SourceEnum.SOURCE_GETTY,
    SourceEnum.SOURCE_GETTY_UNLIMITED,
    SourceEnum.SOURCE_SHUTTERSTOCK_ESSENTIALS,
    SourceEnum.SOURCE_SHUTTERSTOCK_PREMIUM,
    SourceEnum.SOURCE_SHUTTERSTOCK_UNLIMITED,
    SourceEnum.SOURCE_SHUTTERSTOCK_EDITORIAL,
    SourceEnum.SOURCE_SHUTTERSTOCK_CHOICES,
]);

export const RENDERING_BLOCKING_SOURCES = [
    SourceEnum.SOURCE_GETTY,
    SourceEnum.SOURCE_SHUTTERSTOCK_PREMIUM,
    SourceEnum.SOURCE_SHUTTERSTOCK_EDITORIAL,
];

export const DEFAULT_LUMINARY_CONFIG: LuminarySettings = {
    mediaSizeToUse: Luminary.VideoData.PREVIEW_MEDIA_SIZE,
};

export const ORDERED_TEXT_POSITIONS = [
    Luminary.VideoData.TOP_LEFT_TEXT_POSITION,
    Luminary.VideoData.TOP_CENTER_TEXT_POSITION,
    Luminary.VideoData.TOP_RIGHT_TEXT_POSITION,
    Luminary.VideoData.CENTER_LEFT_TEXT_POSITION,
    Luminary.VideoData.CENTER_TEXT_POSITION,
    Luminary.VideoData.CENTER_RIGHT_TEXT_POSITION,
    Luminary.VideoData.BOTTOM_LEFT_TEXT_POSITION,
    Luminary.VideoData.BOTTOM_CENTER_TEXT_POSITION,
    Luminary.VideoData.BOTTOM_RIGHT_TEXT_POSITION,
];

/**
 * Determines the appropriate resolutionValue Luminary should be created with based
 * on whether the user is on a mobile device
 *
 * @returns {number} - 360 for mobile devices, 720 for desktop devices, or 50% if low resolution feature flag is enabled
 */
export function getLuminaryResolutionFromAvailScreenWidth() {
    const baseResolution = isOnMobileDevice() ? 360 : 720;
    const useLowResolution = hasFeatureEnabled('low_luminary_resolution');
    return useLowResolution ? Math.round(baseResolution * 0.5) : baseResolution;
}

export const TEXT_EDITING_OVERFLOW_EVENT = 'nte-text-overflow';
